import styled from "styled-components";

const ContactBlocksContainer = styled.div`
	margin: 0 auto;
	margin-top: 32px;
	margin-bottom: 100px;
`

export default ContactBlocksContainer